import React from 'react';
import memoizeOne from 'memoize-one';

import type { ProviderParticipant } from '@atlaskit/editor-common/collab';
import type { AvatarProps } from '@atlaskit/avatar-group';

import { AvatarBadge } from './AvatarBadge';

const hasSameParticipantBeenUsedBefore = (
	[a]: ProviderParticipant[],
	[b]: ProviderParticipant[],
) => {
	return a.name === b.name && a.avatar === b.avatar && a.sessionId === b.sessionId;
};

export const generateAvatarDescriptorFromParticipant = memoizeOne(
	(participant: ProviderParticipant): AvatarProps => ({
		name: participant.name,
		src: participant.avatar,
		size: 'medium',
		presence: (
			<AvatarBadge
				name={participant.name}
				sessionId={participant.sessionId}
				presenceId={participant.presenceId}
			/>
		),
	}),
	hasSameParticipantBeenUsedBefore,
);

export const generateAvatarDescriptorFromAIProviderParticipant = memoizeOne(
	(
		participant: ProviderParticipant & { onClick?: () => void },
	): AvatarProps & { userId?: string } => {
		return {
			name: participant.name,
			src: '',
			userId: participant.userId,
			size: 'medium',
			onClick: participant?.onClick,
			// Using userId instead of sessionId as we want avatars to show uniquely regardless of the session
			// being used
			presence: <AvatarBadge name={participant.name} sessionId={participant.userId} />,
		};
	},
	hasSameParticipantBeenUsedBefore,
);
